// utils/textShadow.js
export function getSealuminatiShadow(isMobile = false) {
    // For the purple text
    return isMobile
      ? "2px 0px 0px #836EF9, 0px 2px 0px #836EF9, -2px 0px 0px #836EF9, -5px 1px 0px #836EF9"
      : "4px 0px 0px #836EF9, 0px 4px 0px #836EF9, -4px 0px 0px #836EF9, -9px 2px 0px #836EF9";
  }